"use strict";
/**
 * Manages the list of children for an element.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const ObjectList_1 = require("./ObjectList");
const getCore = (i) => i.core;
class ElementChildList extends ObjectList_1.ObjectList {
    constructor(element) {
        super();
        this.element = element;
    }
    getIndex(item) {
        if (item.parent !== this.element) {
            // Performance optimization for new items.
            return -1;
        }
        else {
            return super.getIndex(item);
        }
    }
    itemInList(item) {
        // Performance improvement.
        return item.parent === this.element;
    }
    onAdd(item, index) {
        this.connectParent(item);
        this.element.core.addChildAt(index, item.core);
    }
    onRemove(item, index) {
        item._setParent(undefined);
        this.element.core.removeChildAt(index);
    }
    onSync(removed, added, order) {
        for (let i = 0, n = removed.length; i < n; i++) {
            removed[i]._setParent(undefined);
        }
        for (let i = 0, n = added.length; i < n; i++) {
            this.connectParent(added[i]);
        }
        this.element.core.syncChildren(removed.map(getCore), added.map(getCore), order.map(getCore));
    }
    onSet(item, index, prevItem) {
        prevItem._setParent(undefined);
        this.connectParent(item);
        this.element.core.setChildAt(index, item.core);
    }
    onMove(item, fromIndex, toIndex) {
        this.element.core.moveChild(fromIndex, toIndex);
    }
    connectParent(item) {
        const prevParent = item.parent;
        if (prevParent && prevParent !== this.element) {
            // Cleanup in previous child list.
            const prevChildList = prevParent.childList;
            const index = prevChildList.getIndex(item);
            prevChildList.removeSilently(index);
            // Also clean up element core.
            prevParent.core.removeChildAt(index);
        }
        item._setParent(this.element);
    }
}
exports.ElementChildList = ElementChildList;
//# sourceMappingURL=ElementChildList.js.map